/* src/app/dialogs/promotion-selector-editor/promotion-selector-editor.component.css */
.quantitybutton {
  border-radius: 50%;
  width: 24px;
  height: 24px;
  line-height: 20px;
  margin-left: 2px;
  margin-right: 2px;
}
.mat-mdc-row.result-line {
  background-color: aliceblue !important;
  padding-top: 5px;
  padding-bottom: 5px;
}
.mat-mdc-row.result-line .mat-mdc-cell {
  color: grey !important;
  padding-top: 5px;
  padding-bottom: 5px;
}
.mat-mdc-table {
  width: 100%;
  padding: 40px !important;
}
.imageBox {
  overflow: hidden;
  text-align: center;
  position: relative;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
.imageBox:before {
  content: "";
  display: inline-block;
  height: 200px;
  vertical-align: middle;
}
.imageBox img {
  max-width: 100%;
  height: 200px;
  vertical-align: middle;
}
/*# sourceMappingURL=promotion-selector-editor.component-UVEI3G5B.css.map */
